/**
 * @fileoverview gRPC-Web generated client stub for legebill.site.post_expectation.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: legebill/site/postexpectation/v4/post_expectation.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as legebill_site_postexpectation_v4_post_expectation_pb from '../../../../legebill/site/postexpectation/v4/post_expectation_pb';
import * as legebill_type_workday_pb from '../../../../legebill/type/workday_pb';


export class PostExpectationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreatePostExpectation = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/CreatePostExpectation',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.CreatePostExpectationRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.CreatePostExpectationRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation.deserializeBinary
  );

  createPostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreatePostExpectationRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation>;

  createPostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreatePostExpectationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation>;

  createPostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreatePostExpectationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/CreatePostExpectation',
        request,
        metadata || {},
        this.methodDescriptorCreatePostExpectation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/CreatePostExpectation',
    request,
    metadata || {},
    this.methodDescriptorCreatePostExpectation);
  }

  methodDescriptorChangeMemberListType = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ChangeMemberListType',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ChangeMemberListTypeRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ChangeMemberListTypeRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation.deserializeBinary
  );

  changeMemberListType(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ChangeMemberListTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation>;

  changeMemberListType(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ChangeMemberListTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation>;

  changeMemberListType(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ChangeMemberListTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.PostExpectation) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ChangeMemberListType',
        request,
        metadata || {},
        this.methodDescriptorChangeMemberListType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ChangeMemberListType',
    request,
    metadata || {},
    this.methodDescriptorChangeMemberListType);
  }

  methodDescriptorAddToMemberList = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/AddToMemberList',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse.deserializeBinary
  );

  addToMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse>;

  addToMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse>;

  addToMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.AddToMemberListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/AddToMemberList',
        request,
        metadata || {},
        this.methodDescriptorAddToMemberList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/AddToMemberList',
    request,
    metadata || {},
    this.methodDescriptorAddToMemberList);
  }

  methodDescriptorRemoveFromMemberList = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/RemoveFromMemberList',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse.deserializeBinary
  );

  removeFromMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse>;

  removeFromMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse>;

  removeFromMemberList(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.RemoveFromMemberListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/RemoveFromMemberList',
        request,
        metadata || {},
        this.methodDescriptorRemoveFromMemberList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/RemoveFromMemberList',
    request,
    metadata || {},
    this.methodDescriptorRemoveFromMemberList);
  }

  methodDescriptorListPostExpectations = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ListPostExpectations',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse.deserializeBinary
  );

  listPostExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse>;

  listPostExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse>;

  listPostExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListPostExpectationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ListPostExpectations',
        request,
        metadata || {},
        this.methodDescriptorListPostExpectations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ListPostExpectations',
    request,
    metadata || {},
    this.methodDescriptorListPostExpectations);
  }

  methodDescriptorAddSummaryRecipient = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/AddSummaryRecipient',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse.deserializeBinary
  );

  addSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse>;

  addSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse>;

  addSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.AddSummaryRecipientResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/AddSummaryRecipient',
        request,
        metadata || {},
        this.methodDescriptorAddSummaryRecipient,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/AddSummaryRecipient',
    request,
    metadata || {},
    this.methodDescriptorAddSummaryRecipient);
  }

  methodDescriptorRemoveSummaryRecipient = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/RemoveSummaryRecipient',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse.deserializeBinary
  );

  removeSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse>;

  removeSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse>;

  removeSummaryRecipient(
    request: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.RemoveSummaryRecipientResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/RemoveSummaryRecipient',
        request,
        metadata || {},
        this.methodDescriptorRemoveSummaryRecipient,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/RemoveSummaryRecipient',
    request,
    metadata || {},
    this.methodDescriptorRemoveSummaryRecipient);
  }

  methodDescriptorArchivePostExpectation = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ArchivePostExpectation',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ArchivePostExpectationRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ArchivePostExpectationRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  archivePostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ArchivePostExpectationRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  archivePostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ArchivePostExpectationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  archivePostExpectation(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ArchivePostExpectationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ArchivePostExpectation',
        request,
        metadata || {},
        this.methodDescriptorArchivePostExpectation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ArchivePostExpectation',
    request,
    metadata || {},
    this.methodDescriptorArchivePostExpectation);
  }

  methodDescriptorSetStandardWorkday = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/SetStandardWorkday',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.SetStandardWorkdayRequest,
    legebill_type_workday_pb.Workday,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.SetStandardWorkdayRequest) => {
      return request.serializeBinary();
    },
    legebill_type_workday_pb.Workday.deserializeBinary
  );

  setStandardWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetStandardWorkdayRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_workday_pb.Workday>;

  setStandardWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetStandardWorkdayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_workday_pb.Workday) => void): grpcWeb.ClientReadableStream<legebill_type_workday_pb.Workday>;

  setStandardWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetStandardWorkdayRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_workday_pb.Workday) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/SetStandardWorkday',
        request,
        metadata || {},
        this.methodDescriptorSetStandardWorkday,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/SetStandardWorkday',
    request,
    metadata || {},
    this.methodDescriptorSetStandardWorkday);
  }

  methodDescriptorSetCustomWorkday = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/SetCustomWorkday',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.SetCustomWorkdayRequest,
    legebill_type_workday_pb.Workday,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.SetCustomWorkdayRequest) => {
      return request.serializeBinary();
    },
    legebill_type_workday_pb.Workday.deserializeBinary
  );

  setCustomWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetCustomWorkdayRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_workday_pb.Workday>;

  setCustomWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetCustomWorkdayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_workday_pb.Workday) => void): grpcWeb.ClientReadableStream<legebill_type_workday_pb.Workday>;

  setCustomWorkday(
    request: legebill_site_postexpectation_v4_post_expectation_pb.SetCustomWorkdayRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_workday_pb.Workday) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/SetCustomWorkday',
        request,
        metadata || {},
        this.methodDescriptorSetCustomWorkday,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/SetCustomWorkday',
    request,
    metadata || {},
    this.methodDescriptorSetCustomWorkday);
  }

  methodDescriptorUnsetCustomWorkdays = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/UnsetCustomWorkdays',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.UnsetCustomWorkdaysRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.UnsetCustomWorkdaysRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  unsetCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsetCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  unsetCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsetCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  unsetCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsetCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/UnsetCustomWorkdays',
        request,
        metadata || {},
        this.methodDescriptorUnsetCustomWorkdays,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/UnsetCustomWorkdays',
    request,
    metadata || {},
    this.methodDescriptorUnsetCustomWorkdays);
  }

  methodDescriptorListCustomWorkdays = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ListCustomWorkdays',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse.deserializeBinary
  );

  listCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse>;

  listCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse>;

  listCustomWorkdays(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListCustomWorkdaysResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ListCustomWorkdays',
        request,
        metadata || {},
        this.methodDescriptorListCustomWorkdays,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ListCustomWorkdays',
    request,
    metadata || {},
    this.methodDescriptorListCustomWorkdays);
  }

  methodDescriptorListMemberExpectations = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ListMemberExpectations',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse.deserializeBinary
  );

  listMemberExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse>;

  listMemberExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse>;

  listMemberExpectations(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListMemberExpectationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ListMemberExpectations',
        request,
        metadata || {},
        this.methodDescriptorListMemberExpectations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ListMemberExpectations',
    request,
    metadata || {},
    this.methodDescriptorListMemberExpectations);
  }

  methodDescriptorCreateLeave = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/CreateLeave',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.CreateLeaveRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.Leave,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.CreateLeaveRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.Leave.deserializeBinary
  );

  createLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreateLeaveRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.Leave>;

  createLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreateLeaveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.Leave) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.Leave>;

  createLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.CreateLeaveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.Leave) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/CreateLeave',
        request,
        metadata || {},
        this.methodDescriptorCreateLeave,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/CreateLeave',
    request,
    metadata || {},
    this.methodDescriptorCreateLeave);
  }

  methodDescriptorListLeaves = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/ListLeaves',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse.deserializeBinary
  );

  listLeaves(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse>;

  listLeaves(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse>;

  listLeaves(
    request: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.ListLeavesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/ListLeaves',
        request,
        metadata || {},
        this.methodDescriptorListLeaves,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/ListLeaves',
    request,
    metadata || {},
    this.methodDescriptorListLeaves);
  }

  methodDescriptorDeleteLeave = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/DeleteLeave',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.DeleteLeaveRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.DeleteLeaveRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.DeleteLeaveRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.DeleteLeaveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteLeave(
    request: legebill_site_postexpectation_v4_post_expectation_pb.DeleteLeaveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/DeleteLeave',
        request,
        metadata || {},
        this.methodDescriptorDeleteLeave,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/DeleteLeave',
    request,
    metadata || {},
    this.methodDescriptorDeleteLeave);
  }

  methodDescriptorUnsubscribeReminders = new grpcWeb.MethodDescriptor(
    '/legebill.site.post_expectation.v4.PostExpectationService/UnsubscribeReminders',
    grpcWeb.MethodType.UNARY,
    legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersRequest,
    legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse,
    (request: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersRequest) => {
      return request.serializeBinary();
    },
    legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse.deserializeBinary
  );

  unsubscribeReminders(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse>;

  unsubscribeReminders(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse) => void): grpcWeb.ClientReadableStream<legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse>;

  unsubscribeReminders(
    request: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_postexpectation_v4_post_expectation_pb.UnsubscribeRemindersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.post_expectation.v4.PostExpectationService/UnsubscribeReminders',
        request,
        metadata || {},
        this.methodDescriptorUnsubscribeReminders,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.post_expectation.v4.PostExpectationService/UnsubscribeReminders',
    request,
    metadata || {},
    this.methodDescriptorUnsubscribeReminders);
  }

}

